import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import "./IssueListContainer.css";
import IssueList from "../IssueList/IssueList";
import { connect } from "react-redux";
import {
  loadIssueRequestAction,
  filterKeywordEnteredAction,
  delIssueRequestAction,
  showCreateAction,
  getCurrentIssueRequestAction,
  updateCurIssue
} from "../../redux/actions/issueList";
import CreateIssueModal from "../CreateIssueModal/CreateIssueModal";
import { toast } from "react-toastify";
import { withCookies } from "react-cookie";

class IssueListContainer extends React.Component {
  constructor(props) {
    super(props);

    this.filterEntered = this.filterEntered.bind(this);
    this.createPressed = this.createPressed.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount() {
    const {
      titleID,
      bookType,
      loadedTitleID,
      loadIssueRequestAction,
      getCurrentIssueRequestAction,
      updateCurIssue
    } = this.props;

    if (titleID !== loadedTitleID) {
      loadIssueRequestAction(titleID, bookType === "pdf_books");

      if (bookType === "pdf_books") {
        updateCurIssue({ currentIssue: null });
        getCurrentIssueRequestAction(titleID);
      }
    }
  }

  filterEntered(event) {
    this.props.filterKeywordEnteredAction({ keyword: event.target.value });
  }

  createPressed() {
    const isPdf = this.props.bookType === "pdf_books";
    this.props.showCreateAction({ isPdf });
  }

  handleDelete(anIssue) {
    if (window.confirm("Delete " + anIssue.issue + "?") !== true) {
      return;
    }

    const { issues, bookType } = this.props;

    this.props.delIssueRequestAction(
      anIssue,
      bookType === "pdf_books",
      issues,
      toast
    );
  }

  render() {
    const {
      titleID,
      loadedTitleID,
      errMsg,
      issues,
      keyword,
      cookies,
      currentIssueID
    } = this.props;
    const isLoading = titleID !== loadedTitleID;
    const isAdmin = cookies.get("role") === "admin";

    return (
      <React.Fragment>
        <Container>
          <Row className="top_row">
            <Col>
              <Form.Control
                autoFocus
                type="text"
                value={keyword}
                placeholder="Filter"
                onChange={this.filterEntered}
              />
            </Col>
            {isAdmin && (
              <Col className="create_issue_btn_container">
                <Button
                  className="create_issue_btn"
                  variant="info"
                  onClick={this.createPressed}
                >
                  Create
                </Button>
              </Col>
            )}
          </Row>
          <Row className="top_issue_row">
            <IssueList
              isAdmin={isAdmin}
              handleDelete={this.handleDelete}
              isLoading={isLoading}
              issues={issues}
              errMsg={errMsg}
              keyword={keyword}
              currentIssueID={currentIssueID}
            />
          </Row>
          <Row className="bottom_row">
            {!isLoading && <Col>Total {issues.length} book(s)</Col>}
          </Row>
        </Container>
        <CreateIssueModal
          bookType={this.props.bookType}
          titleID={this.props.titleID}
        />
      </React.Fragment>
    );
  }
}

const mapState = (state, ownProps) => {
  const { issueList } = state;

  if (ownProps.bookType === "pdf_books") {
    return {
      loadedTitleID: issueList.pdfLoadedID,
      errMsg: issueList.pdfErrMsg,
      issues: issueList.pdfIssues,
      keyword: issueList.keyword,
      currentIssueID: issueList.currentIssueID
    };
  } else {
    return {
      loadedTitleID: issueList.webLoadedID,
      errMsg: issueList.webErrMsg,
      issues: issueList.webIssues,
      keyword: issueList.keyword,
      currentIssueID: issueList.currentIssueID
    };
  }
};

const mapDispatch = {
  loadIssueRequestAction,
  filterKeywordEnteredAction,
  delIssueRequestAction,
  showCreateAction,
  getCurrentIssueRequestAction,
  updateCurIssue
};

export default withCookies(
  connect(
    mapState,
    mapDispatch
  )(IssueListContainer)
);
